import { baseApi } from "@/api/baseApi";
import { ORGANIZATIONS_ADMIN_TAGS } from "@/api/organizations-admin.constraints";
import { AUTHENTICATION_TAGS } from "@/api/authentication.constraints";
import type {
  Organization,
  OrganizationFormData,
  OrganizationLlmModelConfig,
  OrganizationLlmModelConfigUpdate,
} from "@/types/organization";

type OrganizationStyleGuideUpdate = {
  styleGuideSection1?: string | null;
  styleGuideSection11?: string | null;
  styleGuideSection19?: string | null;
  styleGuideSection18?: string | null;
};

export const organizationsAdminApi = baseApi.injectEndpoints({
  overrideExisting: false,
  endpoints: builder => ({
    getOrganizations: builder.query<Organization[], void>({
      providesTags: [ORGANIZATIONS_ADMIN_TAGS.ORGANIZATIONS_LIST_TAG],
      query: () => ({
        url: "/pf-auth/organizations",
      }),
    }),
    updateOrganization: builder.mutation<void, { id: string; data: Partial<OrganizationFormData> }>({
      invalidatesTags: [
        ORGANIZATIONS_ADMIN_TAGS.ORGANIZATIONS_LIST_TAG,
        ORGANIZATIONS_ADMIN_TAGS.ORGANIZATION_DETAILS_TAG,
        AUTHENTICATION_TAGS.AUTHENTICATION_TAG,
      ],
      query: ({ id, data }) => ({
        url: `/pf-auth/organizations/${id}`,
        method: "PATCH",
        data,
      }),
    }),
    updateOrganizationStyleGuide: builder.mutation<void, { id: string; data: OrganizationStyleGuideUpdate }>({
      invalidatesTags: [
        ORGANIZATIONS_ADMIN_TAGS.ORGANIZATIONS_LIST_TAG,
        ORGANIZATIONS_ADMIN_TAGS.ORGANIZATION_DETAILS_TAG,
      ],
      query: ({ id, data }) => ({
        url: `/pf-auth/organizations/${id}/style-guide`,
        method: "PATCH",
        data,
      }),
    }),
    getOrganizationLlmModelConfig: builder.query<OrganizationLlmModelConfig, string>({
      providesTags: [ORGANIZATIONS_ADMIN_TAGS.ORGANIZATION_DETAILS_TAG],
      query: id => ({
        url: `/pf-auth/organizations/${id}/llm-model-config`,
      }),
    }),
    updateOrganizationLlmModelConfig: builder.mutation<void, { id: string; data: OrganizationLlmModelConfigUpdate }>({
      invalidatesTags: [ORGANIZATIONS_ADMIN_TAGS.ORGANIZATION_DETAILS_TAG],
      query: ({ id, data }) => ({
        url: `/pf-auth/organizations/${id}/llm-model-config`,
        method: "PATCH",
        data,
      }),
    }),
  }),
});

export const {
  useGetOrganizationsQuery,
  useUpdateOrganizationMutation,
  useUpdateOrganizationStyleGuideMutation,
  useGetOrganizationLlmModelConfigQuery,
  useUpdateOrganizationLlmModelConfigMutation,
} = organizationsAdminApi;
